import { BrowserRouter, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import { useEffect } from "react";

import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import CreateJob from "./pages/NewCreateJob";
import JobDetails from "./pages/JobDetails";
import UserManagement from "./pages/UserManagement";
import JobReports from "./pages/JobReports";

import ProtectedRoute from "./routes/ProtectedRoute";

// ✅ IMPORT THESE
import ProfileModal from "./components/ProfileModal";
import Toast from "./components/Toast";

// 🔥 Wrapper to listen logout event
function AppWrapper() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleLogout = () => {
      alert("Session expired. Please login again.");
      navigate("/", { replace: true });
    };

    window.addEventListener("logout", handleLogout);

    return () => {
      window.removeEventListener("logout", handleLogout);
    };
  }, [navigate]);

  return (
    <>
      <Routes>

        {/* LOGIN */}
        <Route
          path="/"
          element={
            localStorage.getItem("token") ? (
              <Navigate to="/dashboard" />
            ) : (
              <Login />
            )
          }
        />

        {/* DASHBOARD */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        {/* CREATE JOB */}
        <Route
          path="/create-job"
          element={
            <ProtectedRoute>
              <CreateJob />
            </ProtectedRoute>
          }
        />

        {/* JOB DETAILS */}
        <Route
          path="/jobs/:id"
          element={
            <ProtectedRoute>
              <JobDetails />
            </ProtectedRoute>
          }
        />

        {/* USERS */}
        <Route
          path="/users"
          element={
            <ProtectedRoute>
              <UserManagement />
            </ProtectedRoute>
          }
        />

        {/* REPORTS */}
        <Route
          path="/job/reports"
          element={
            <ProtectedRoute>
              <JobReports />
            </ProtectedRoute>
          }
        />

        {/* DEFAULT */}
        <Route path="*" element={<Navigate to="/" />} />

      </Routes>

      {/* ✅ ADD HERE (GLOBAL COMPONENTS) */}
      <ProfileModal />
      <Toast />
    </>
  );
}

// 🔥 ROOT APP
export default function App() {
  return (
    <BrowserRouter>
      <AppWrapper />
    </BrowserRouter>
  );
}